import { useEffect } from 'react';

import useRefValue from './useRefValue';
import useLocationHash from './useLocationHash';
import useIsInitialRender from './useIsInitialRender';

function useNavigationHashChage(onNavigationHashChange, {
  defaultHash,
  skipInitialRender = true,
} = {}) {
  const onNavigationHashChangeRef = useRefValue(onNavigationHashChange);

  const isInitialRender = useIsInitialRender();
  const [hash] = useLocationHash();

  useEffect(() => {
    if (!skipInitialRender || (skipInitialRender && !isInitialRender)) {
      onNavigationHashChangeRef.current(hash || defaultHash);
    }
  }, [hash]);
}

export default useNavigationHashChage;
